{
  "en": {
    "tenant": {
      "actions": {
        "changeCompanyLogo": "Change Logo (png required)",
        "changeThemeColor": "Pick a new theme color"
      },
      "labels": {
        "customerThemeColor": "Customer theme color",
        "customerThemeColorExlainer": "This color will be used for the customer portal. Impersonate a customer to see this in action."
      },
      "picture_logo_format": {
        "round": "Round Logo",
        "square": "Square Logo"
      }
    }
  }
}